import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { BreadCrumbs } from '../../Layout/Header/BreadCrumbs';

import { ChartOfAccountCreate } from '.';

import { AddRecord } from '@components/ActionButtons';
import { BoxBodyContainer, BoxHeaderTitle } from '@components/Box';
import { BreadcrumbsContainer } from '@components/BreadcrumbsContainer';
import { GridHeaderMenuTitle } from '@components/HeaderTitle';
import { Modal } from '@components/Modal';
import { routes } from '@config/routes';

export const ChartOfAccount: React.FC = () => {
  const [showCreateAccount, SetShowCreateAccount] = useState(false);

  const baseBreadCrumbs = [{ link: 'Accounting', to: '' }];

  const isOnChartOfAccountsPage = location.pathname === routes.CHARTOFACCOUNTS;

  const breadCrumbLinks = isOnChartOfAccountsPage
    ? baseBreadCrumbs
    : [...baseBreadCrumbs];

  return (
    <>
      <div className="p-4 space-y-4">
        <BreadcrumbsContainer>
          <div className="lg:text-sm md:text-sm text-xs text-gray-500">
            Accounting
          </div>
          <div className="lg:flex md:flex hidden">
            <BreadCrumbs links={breadCrumbLinks} />
          </div>
        </BreadcrumbsContainer>

        <div>
          <div className="flex justify-between items-center space-x-5">
            <BoxHeaderTitle>
              <GridHeaderMenuTitle>
                <div className="lg:text-2xl md:text-xl text-sm lg:font-black md:font-black font-bold">
                  Chart of Accounts
                </div>
              </GridHeaderMenuTitle>
            </BoxHeaderTitle>

            <div className="">
              <div className="flex flex-row space-x-1">
                <AddRecord
                  label="New Account"
                  onClick={() => SetShowCreateAccount(true)}
                />
              </div>
              {showCreateAccount && (
                <>
                  <Modal show={true}>
                    <ChartOfAccountCreate
                      onClose={() => SetShowCreateAccount(false)}
                    />
                  </Modal>
                </>
              )}
            </div>
          </div>

          <div className="p-2 bg-white rounded-b-xl rounded-tr-xl">
            <BoxBodyContainer>
              <Outlet />
            </BoxBodyContainer>
          </div>
        </div>
      </div>
    </>
  );
};
